import { Preview } from "../../../../types/IAction";
import * as actions from "../../../actions/comisionMembresia";
import {
  GetMembresiaTrackingClubAlcance,
  PutMembresiaTrackingCompromisos,
  PutMembresiaTrackingAsesores
} from "../../../reducers/comisionMembresia";
import MembresiaTrackingClubCompromisos from "../../../../types/MembresiaTrackingClubCompromisos";
import MembresiaTrackingAsesor from "../../../../types/MembresiaTrackingAsesor";

export interface TrackingAsesoresDispatcher {
  getTrackingByPeriodoAndClub: (
    periodo: string,
    idClub: number
  ) => Promise<Preview<GetMembresiaTrackingClubAlcance>>;
  putCompromisoClub: (
    periodo: string,
    idClub: number,
    compromisos: MembresiaTrackingClubCompromisos
  ) => Promise<Preview<PutMembresiaTrackingCompromisos>>;
  putAsesoresTracking: (
    periodo: string,
    idClub: number,
    asesores: MembresiaTrackingAsesor[]
  ) => Promise<Preview<PutMembresiaTrackingAsesores>>;
}

export const trackingAsesoresDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => TrackingAsesoresDispatcher = dispatch => ({
  getTrackingByPeriodoAndClub: (periodo: string, idClub: number) => {
    return dispatch(actions.getTrackingByPeriodoAndClub(periodo, idClub));
  },
  putCompromisoClub: (
    periodo: string,
    idClub: number,
    compromisos: MembresiaTrackingClubCompromisos
  ) => {
    return dispatch(actions.putCompromisoClub(periodo, idClub, compromisos));
  },
  putAsesoresTracking: (
    periodo: string,
    idClub: number,
    asesores: MembresiaTrackingAsesor[]
  ) => {
    return dispatch(actions.putAsesoresTracking(periodo, idClub, asesores));
  }
});
